<template>
  <div>
    <div id="mainDiv" class="container roundedBorder secondary-bg primary-fg">
      <h2>Settings</h2>

      <!--<h4 class="secondary-fg">Account Settings</h4>-->

      <div class="row">
        <div class="col s12 m12">
          <div class="card">
            <div class="card-content secondary-bg">
              <p>
                Reset your master password by sending a password reset e-mail
              </p>
            </div>
            <div class="card-action secondary-bg">
              <a
                class="waves-effect waves-light btn primary-bg"
                v-on:click="sendPasswordResetMail"
                >Reset password</a
              >
            </div>
          </div>
        </div>

        <div class="col s12 m12">
          <div class="card">
            <div class="card-content secondary-bg">
              <p>
                Initialize or update client side encryption
              </p>
            </div>
            <div class="card-action secondary-bg">
              <router-link to="/pin/initialize">
                <a class="waves-effect waves-light btn primary-bg"
                  >Manage cse</a
                >
              </router-link>
            </div>
          </div>
        </div>

        <div class="col s12 m6">
          <div class="card">
            <div class="card-content secondary-bg">
              <p>Import your passwords from Google</p>
            </div>
            <div class="card-action secondary-bg">
              <router-link
                class="waves-effect waves-light btn primary-bg"
                to="/passwords/import"
                >Import passwords</router-link
              >
            </div>
          </div>
        </div>

        <div class="col s12 m6">
          <div class="card">
            <div class="card-content secondary-bg">
              <p>Export your passwords from LockerApp</p>
            </div>
            <div class="card-action secondary-bg">
              <a
                class="waves-effect waves-light btn modal-trigger primary-bg"
                href="#exportPasswordsConfirmationModal"
                >Export passwords</a
              >
            </div>
          </div>
        </div>
        <div class="col s12 m12">
          <div class="card">
            <div class="card-content secondary-bg">
              <p>
                Remove your account and all of the data related to your account
              </p>
            </div>
            <div class="card-action secondary-bg">
              <a
                class="waves-effect waves-light btn modal-trigger error-bg"
                href="#accountDeleationModal"
                >Remove account</a
              >
            </div>
          </div>
        </div>
      </div>

      <blockquote></blockquote>

      <p></p>
    </div>

    <!-- Account Deleation Modal Structure -->
    <div id="accountDeleationModal" class="modal">
      <div class="modal-content">
        <h4>Are you sure?</h4>
        <p>
          Would you really like to delete all of your data associated with your
          account at LockerApp? This action will clear all of the passwords,
          notes, and any data related to your account. Your account will be
          permanently delated and this action is irreversible!
        </p>
        <blockquote>
          Enter
          <span class="error-fg">
            {{ desiredStringDeleation }}
          </span>
          to confirm that you really want to remove your account
        </blockquote>
        <div class="row">
          <div class="row">
            <div class="input-field col s12">
              <input
                type="text"
                v-model="enteredStringDeleation"
                style="border-color: var(--primary-bg-color) !important"
              />
              <label class="active black-text">Confirmation</label>
              <span class="helper-text" data-error="wrong" data-success="right"
                >Confirm that you would like to remove your account at LockerApp
                and all of the data</span
              >
            </div>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <a href="#!" class="modal-close waves-effect waves-green btn-flat"
          >Cancel</a
        >
        <a
          href="#!"
          class="modal-close waves-effect waves-red btn-flat error-fg"
          v-on:click="deleteAccount"
          :disabled="desiredStringDeleation != enteredStringDeleation"
          >Delete my account</a
        >
      </div>
    </div>

    <!-- Export Passwords Modal Structure -->
    <div id="exportPasswordsConfirmationModal" class="modal">
      <div class="modal-content">
        <h4>Exporting your passwords</h4>
        <p>
          This action will export all of your passwords within a csv file. The
          passwords will be in plain text. Please confirm that you would like to
          export your passwords.
        </p>
      </div>
      <div class="modal-footer">
        <a href="#!" class="modal-close waves-effect waves-green btn-flat"
          >Cancel</a
        >
        <a
          href="#!"
          class="modal-close waves-effect waves-blue btn-flat primary-bg primary-fg"
          v-on:click="exportPasswords"
          >Yes</a
        >
      </div>
    </div>
  </div>
</template>

<script>
import firebase from "firebase/app";
import "firebase/auth";
import M from "materialize-css";

const EXPORT_PASSWORDS_API_ENDPOINT =
  process.env.NODE_ENV === "production"
    ? "/api/passwords/export"
    : "http://localhost:7777/api/passwords/export";

export default {
  name: "Settings",
  components: {},
  data: function() {
    return {
      name: "",
      desiredStringDeleation: "delete my account at lockerapp",
      enteredStringDeleation: ""
    };
  },
  methods: {
    updateName: function() {
      let targetName = this.name;
      firebase
        .auth()
        .currentUser.updateProfile({
          displayName: targetName
        })
        .then(() => {
          M.toast({ html: `Successfully updated name to ${targetName}!` });
        });
    },
    sendPasswordResetMail: function() {
      let currentUserEmail = firebase.auth().currentUser.email;
      firebase
        .auth()
        .sendPasswordResetEmail(currentUserEmail)
        .then(() => {
          M.toast({ html: `Successfully send a password reset e-mail!` });
        });
    },
    deleteAccount: function() {
      let vueInstance = this;
      firebase
        .auth()
        .currentUser.delete()
        .then(() => {
          vueInstance.$router.push("/");
        })
        .catch(error => {
          M.toast({ html: `Error: ${error.message}!` });
        });
    },
    exportPasswords: async function() {
      let cseEnabled = await this.isCSEEnabled();
      if (cseEnabled) {
        alert("Can't export passwords when client side encryption is enabled");
        return;
      }
      let idToken = await this.getIdToken();
      const options = {
        method: "GET",
        headers: {
          Authorization: idToken
        }
      };
      let response = await fetch(EXPORT_PASSWORDS_API_ENDPOINT, options);

      const responseBody = await response.blob();

      if (window.navigator.msSaveOrOpenBlob) {
        window.navigator.msSaveBlob(responseBody, "LockerApp Passwords.csv");
      } else {
        var a = window.document.createElement("a");

        a.href = window.URL.createObjectURL(responseBody, {
          type: "text/csv"
        });
        a.download = "LockerApp Passwords.csv";
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
      }
    },
    getIdToken: async function() {
      let idToken = await firebase
        .auth()
        .currentUser.getIdToken(false)
        .then(function(idToken) {
          return idToken;
        })
        .catch(function(error) {
          // Handle error
          console.error(
            `Failed while fetching the idToken from the firebase: ${error.meesage}`
          );
        });

      return idToken;
    }
  },
  mounted: async function() {
    // If there is no user navigate to the root page
    if (!firebase.auth().currentUser) {
      this.$router.push("/");
      return;
    }

    // Fetch the name
    this.name = await firebase.auth().currentUser.displayName;

    M.AutoInit();
  },
  metaInfo: {
    title: "Settings",
    meta: [
      {
        name: "description",
        content:
          "Settings page for LockerApp, you can update your name and password. | Password Manager | Encrypted Passwords | Encrypted Notes | Generate a new strong password"
      },
      { name: "application-name", content: "LockerApp" },
      { name: "author", content: "Emre Biçer" },
      {
        name: "keywords",
        content:
          "LockerApp, Locker App, Locker, App, Password Manager, Password, Safe, Application, Last Password, Locker, Notes, Note Application, Mobile Application, Web Application"
      }
    ]
  }
};
</script>

<style scoped>
#mainDiv {
  padding: 20px;
}

blockquote {
  border-left: 5px solid var(--primary-bg-color);
}

.card {
  box-shadow: 2px 2px 2px 2px var(--primary-bg-color);
  border: 0px solid var(--primary-bg-color);
  background-color: black;
}
</style>
